import { Fragment, useContext } from "react";
import appStyles from "../../../App.module.css";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import { IPortuguesePurchasePathContext } from "../../config/interface";

const PPStepper = () => {
  const { currentStep, totalSteps } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;
  const tempArray = new Array(totalSteps).fill(0);
  return (
    <div className={appStyles.progressWrapper}>
      {tempArray.map((value, index) => {
        return (
          <Fragment key={index}>
            <div className={`${appStyles.progressDot} ${index <= currentStep ? appStyles.progressDone : ""}`}></div>
            {index < totalSteps - 1 && (
              <div
                className={`${appStyles.progressLine} ${index <= currentStep - 1 ? appStyles.progressDone : ""}`}
              ></div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default PPStepper;
